import { Button, Chip, Dialog, Grid, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { SimpleDocument } from 'kent-process-monitor-api/src/api';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { closeConsentDialog, getDocumentDetails, getDocumentsData } from '../../../slices/dataController';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import styles from './style.module.scss';

interface Props {
    sessionId: string;
    isExpanded: boolean;
}

const DocumentsService: React.FC<Props> = ({ sessionId, isExpanded }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { documents, documentContent, documentDialogOpen } = useAppSelector((state) => state.dataController);
    const [ numPages, setNumPages ] = useState(null);
    const [ pageToShow, setPageToShow ] = useState(1);

    useEffect(() => {
        if (isExpanded) {
            dispatch(getDocumentsData(sessionId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ isExpanded ]);

    const openDetails = (documentUuid) => {
        dispatch(getDocumentDetails(documentUuid));
    };

    const handleClose = () => {
        setPageToShow(1);
        dispatch(closeConsentDialog());
    };

    const onDocumentLoadSuccess = ({ numPages: nextNumPages }) => {
        setNumPages(nextNumPages);
    };

    return (
        <>
            Signed documents
            { documents?.map((doc: SimpleDocument, index: number) => (
                <Chip
                    key={ index }
                    style={ { textDecoration: 'underline', cursor: 'pointer', margin: '0 1rem' } }
                    label={ doc.title }
                    variant="outlined"
                    onClick={ () => openDetails(doc.uuid) }></Chip>
            )) }

            <Dialog onClose={ handleClose } open={ documentDialogOpen } maxWidth="md" className={ styles.dialog }>
                <Document file={ `data:application/pdf;base64,${ documentContent }` } onLoadSuccess={ onDocumentLoadSuccess }>
                    <Page pageNumber={ pageToShow } />
                </Document>
                <Grid container alignItems="center" className={ styles.buttonGroupPages } justifyContent="center">
                    <Button className={ styles.buttonsPages } disabled={ pageToShow === 1 } onClick={ () => setPageToShow((pageToShow) => pageToShow - 1) }>
                        -
                    </Button>
                    { pageToShow } { t('pdfpage') } { numPages }
                    <Button className={ styles.buttonsPages } disabled={ pageToShow === numPages }
                            onClick={ () => setPageToShow((pageToShow) => pageToShow + 1) }>
                        +
                    </Button>
                </Grid>
            </Dialog>
        </>
    );
};

export default DocumentsService;



